import { AlertCircle, Loader2, type LucideIcon } from 'lucide-react';
import { Button } from '@/components/atoms/button';

interface CollectionErrorStateProps {
  title?: string;
  onRetry?: () => void;
}

export function CollectionErrorState({
  title = 'Failed to load',
  onRetry,
}: CollectionErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-muted-foreground">
      <AlertCircle size={24} />
      <p className="text-sm">{title}</p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}

interface CollectionEmptyStateProps {
  icon: LucideIcon;
  title: string;
}

export function CollectionEmptyState({ icon: Icon, title }: CollectionEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-muted-foreground">
      <Icon size={24} className="text-muted-foreground/40" />
      <p className="text-sm">{title}</p>
    </div>
  );
}

interface CollectionLoadingStateProps {
  title?: string;
}

export function CollectionLoadingState({ title = 'Loading…' }: CollectionLoadingStateProps) {
  return (
    <div className="flex items-center justify-center text-sm text-muted-foreground">
      <Loader2 size={16} className="mr-2 animate-spin" />
      {title}
    </div>
  );
}
